import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={13.009}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 4284 8463"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974620208400">
        <g id="XMLID_8_">
          <path
            d="M3151 4435c674 361 1133 1072 1133 1889 0 836-481 1561-1181 1914 864-1141 797-2158 571-2833-140-415-351-746-523-970z"
            className="fil0"
          />
          <path
            d="M2649 4243c33 7 66 16 98 26 88 85 521 534 744 1206 328 983 73 1962-758 2908-36 10-72 19-108 28 853-1945 280-3596 24-4168z"
            className="fil0"
          />
          <path
            d="M2413 4199c187 371 965 2142-20 4252-51 6-102 10-154 12V4184c59 3 117 7 174 15zM2045 4184v4279c-52-2-103-6-154-12-992-2125-197-3900-16-4253 56-7 112-11 170-14z"
            className="fil0"
          />
          <path
            d="M1548 4265c30-8 60-16 90-23-255 563-836 2215 21 4169-36-9-72-18-107-28-831-946-1085-1925-754-2910 226-673 663-1124 750-1208z"
            className="fil0"
          />
          <path
            d="M1145 4428c-173 224-387 557-529 975-229 675-299 1694 565 2835C481 7885 0 7160 0 6324c0-822 465-1537 1145-1896zM2191 3096h195v989h-195zM1899 3096h195v989h-195zM1594 3096h195v989h-195zM2495 3096h195v989h-195zM2045 0h195v2998h-195z"
            className="fil0"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default SvgComponent
